import React from 'react';
import { useSelector } from 'react-redux';
import { getSelectedBank } from 'src/redux/modules/bankSelection/bankSelection.selectors';
import { getDisplayTradeDate } from 'src/redux/modules/funds/UserFunds/userFunds.selectors';
import { getDeliveryMethod } from 'src/redux/modules/sellDeliveryMethod/sellDeliveryMethod.selectors';
import {
  getCollegeDistributeAddress,
  getCollegeDistributeMultiplePayeeOrAddress,
  getFundsByAddressLookupForCollegeDistribute,
  getHasMultipleNames,
  getIsEFT,
  getIsTakeHomeEstimated,
  getSelectedSellFundsList,
  getSellTakeHomeAmount,
  getSellTransactionDeductionTotal,
  getSellTransactionTotal,
} from 'src/redux/modules/sellTransaction/sellTransaction.selectors';
import {
  DELIVERY_MAIL_CHECK,
  DELIVERY_MAIL_CHECK_TO_SCHOOL,
} from 'src/settings/settings';
import SellMultipleAddressReview from '../../Sell/SellReview/SellMultipleAddressReview/SellMultipleAddressReview';
import SellTransactionsReview from '../../Sell/SellReview/SellTransactionsReview/SellTransactionsReview';
import If from '../../Shared/If/If';
import StepExpanded from '../../Shared/StepExpanded/StepExpanded';
import CollegeDistributeDisclaimerNote from '../CollegeDistributeDisclaimerNote/CollegeDistributeDisclaimerNote';
import './CollegeDistributeReview.scss';
import '../CollegeDistributeSteps/SchoolAddress.scss';
import '../../Sell/DeliveryMethodForm/DeliveryMethodForm.scss';
import { getSelectedSchool } from 'src/redux/modules/schoolSelection';
import MailCheckToSchool from '../MailCheckToSchool/MailCheckToSchool';
import { getStudentDetails } from 'src/redux/modules/studentDetail';

const CollegeDistributeReview: React.VFC = () => {
  const collegeDistributeAddress = useSelector(getCollegeDistributeAddress);
  const collegeDistributeMultiplePayeeOrAddress = useSelector(
    getCollegeDistributeMultiplePayeeOrAddress
  );
  const deliveryMethod = useSelector(getDeliveryMethod);
  const displayTradeDate = useSelector(getDisplayTradeDate);
  const fundsByAddressLookup = useSelector(
    getFundsByAddressLookupForCollegeDistribute
  );
  const hasMultipleNames = useSelector(getHasMultipleNames);
  const isEFT = useSelector(getIsEFT);
  const isTakeHomeEstimated = useSelector(getIsTakeHomeEstimated);
  const selectedBank = useSelector(getSelectedBank);
  const selectedFunds = useSelector(getSelectedSellFundsList);
  const sellTakeHomeAmount = useSelector(getSellTakeHomeAmount);
  const sellTotalAmount = useSelector(getSellTransactionTotal);
  const sellTotalDeduction = useSelector(getSellTransactionDeductionTotal);
  const selectedSchool = useSelector(getSelectedSchool);
  const studentDetail = useSelector(getStudentDetails);
  return (
    <>
      <StepExpanded>
        <div className="college-distribute-review-sell-review">
          <div className="row hidden-xs college-distribute-review-heading">
            <div className="col-md-5 col-sm-6 college-distribute-review-delivery">
              DELIVERY METHOD
            </div>
            <div className="col-md-5 col-sm-6">FROM</div>
            <div className="col-md-2 hidden-sm college-distribute-review-amount">
              AMOUNT
            </div>
          </div>
          <If
            test={
              deliveryMethod === DELIVERY_MAIL_CHECK_TO_SCHOOL && selectedSchool
            }
          >
            <MailCheckToSchool
              deliveryMethod={deliveryMethod}
              displayTradeDate={displayTradeDate}
              isTakeHomeEstimated={isTakeHomeEstimated}
              selectedFunds={selectedFunds}
              selectedSchool={selectedSchool}
              sellTakeHomeAmount={sellTakeHomeAmount}
              sellTotalAmount={sellTotalAmount}
              studentDetail={studentDetail}
            />
          </If>
          <If
            test={
              isEFT ||
              (deliveryMethod === DELIVERY_MAIL_CHECK &&
                !collegeDistributeMultiplePayeeOrAddress)
            }
          >
            <SellTransactionsReview
              address={collegeDistributeAddress}
              deliveryMethod={deliveryMethod}
              displayTradeDate={displayTradeDate}
              hasMultipleNames={hasMultipleNames}
              isEFT={isEFT}
              isTakeHomeEstimated={isTakeHomeEstimated}
              multipleAddressFlag={collegeDistributeMultiplePayeeOrAddress}
              selectedBank={selectedBank}
              selectedFunds={selectedFunds}
              sellTakeHomeAmount={sellTakeHomeAmount}
              sellTotalAmount={sellTotalAmount}
              sellTotalDeduction={sellTotalDeduction}
            />
          </If>
          <If
            test={
              deliveryMethod === DELIVERY_MAIL_CHECK &&
              collegeDistributeMultiplePayeeOrAddress
            }
          >
            <SellMultipleAddressReview
              deliveryMethod={deliveryMethod}
              displayTradeDate={displayTradeDate}
              fundsByAddressLookup={fundsByAddressLookup}
            />
          </If>
          <CollegeDistributeDisclaimerNote
            selectedProductTypes={selectedFunds.map((fund) => fund.productType)}
          />
        </div>
      </StepExpanded>
    </>
  );
};

export default CollegeDistributeReview;
